/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSpecificiteCoursGridDto } from './FcbSpecificiteCoursGridDto';
import {
    FcbSpecificiteCoursGridDtoFromJSON,
    FcbSpecificiteCoursGridDtoFromJSONTyped,
    FcbSpecificiteCoursGridDtoToJSON,
} from './FcbSpecificiteCoursGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSpecificiteCoursGridDtoPaginatedResults
 */
export interface FcbSpecificiteCoursGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSpecificiteCoursGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSpecificiteCoursGridDto>}
     * @memberof FcbSpecificiteCoursGridDtoPaginatedResults
     */
    results?: Array<FcbSpecificiteCoursGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSpecificiteCoursGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSpecificiteCoursGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSpecificiteCoursGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSpecificiteCoursGridDtoPaginatedResultsFromJSON(json: any): FcbSpecificiteCoursGridDtoPaginatedResults {
    return FcbSpecificiteCoursGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSpecificiteCoursGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSpecificiteCoursGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSpecificiteCoursGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSpecificiteCoursGridDtoPaginatedResultsToJSON(value?: FcbSpecificiteCoursGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSpecificiteCoursGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

